<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li>Contact</li>
            </ul>
            <h2>Contact</h2>
        </div>
    </div>
    <div class="shape9"><img src="images/shape8.svg" alt="image"></div>
</div>

<div class="contact-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Contact Details</span>
                    <h2>Get in Touch</h2>
                    <p>SUCCESS PARAMEDICAL INSTITUTE <br> THE MOST TRUSTED PARAMEDICAL INSTITUTE in SURAT</p>
                    <ul>
                        <!-- <li>
                            <div class="icon">
                                <i class="fa-solid fa-location-dot"></i>
                            </div>
                            <h3>Our Address</h3>
                            <p>117-Samrat Nagar Society, Kapodra, Surat-395009</p><br>
                            <p>3rd Floor, Gruham Empire, Near Shrusti Row House, Sayan Road, Amroli, Surat-394107</p>
                        </li> -->
                        <li>
                            <div class="icon">
                                <i class="fa-solid fa-location-dot"></i>
                            </div>
                            <h3>Our Branches</h3>
                            <p> <a href="https://maps.app.goo.gl/spTco3ErQeisQBMR7" target="_blank">Head Office<br>
                                    Samrat Nagar Society, Kapodra, varachha, Surat-395009</a></p><br>
                            <p> <a href="https://maps.app.goo.gl/uUeDzUUmWoHXLX7b6" target="_blank">Branch 1 <br>
                                    Bardoli</a></p><br>
                            <p> <a href="https://maps.app.goo.gl/oCzu2bXRLbq2KiWX9" target="_blank">Branch 2 <br>
                                    Ankleshwar</a></p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="fa-solid fa-phone"></i>
                            </div>
                            <h3>Contact</h3>
                            <p>Mobile: <a href="tel:+919924018454">+91 99240 18454</a></p>
                            <p><a
                                    href="mailto:successparamedicalinstitute8&#64;gmail.com">successparamedicalinstitute8&#64;gmail.com</a>
                            </p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="fa-solid fa-clock"></i>
                            </div>
                            <h3>Hours of Operation</h3>
                            <p>Monday - Saturday <br> 09:00 AM - 04:00 PM</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-form" style="background-image: url(images/register-shape.jpg);">
                    <h2>Ready to Get Started?</h2>
                    <p>Your email address will not be published. Required fields are marked *</p>
                    <form>
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required name="name" type="text" class="form-control" id="name"
                                        placeholder="Your name">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required name="email" type="text" class="form-control" id="email"
                                        placeholder="Your email address">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <input require name="number" type="text" class="form-control" id="number"
                                        placeholder="Your phone number">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea required name="message" id="message" cols="30" rows="5"
                                        class="form-control" placeholder="Write your message..."></textarea>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="default-btn">Send Message<span></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="premium-access-area bg-f9f9f9 ptb-100">
    <app-premium-access></app-premium-access>
    <div class="shape3"><img src="images/shape3.png" alt="image"></div>
    <div class="shape4"><img src="images/shape4.png" alt="image"></div>
    <div class="shape8"><img src="images/shape7.png" alt="image"></div>
</div>

<div id="map">
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.433968544763!2d72.87290240425509!3d21.21463324006369!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2c13dba400114d41%3A0x262373c0a7223cf6!2sSuccess%20Paramedical%20Institute!5e0!3m2!1sen!2sin!4v1755681689486!5m2!1sen!2sin"
        width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>